import { defineStore } from 'pinia';
import PaiementAjax from '@/services/PaiementAjax';
import useAppStore from '@/store/appStore';

export default defineStore('paiementStore', {
  state: () => ({
    chargement: false,
    eleveEcoleGuid: null,
    coursPageConfirmation: [],
    coursElevePageConfirmation: [],
    idEleve: -1,
    coursModifies: [],
    blocs: [],
    coursEleveNoPlaceListeAttente: [],
    peutPayer: false,
    transactions: [],
    coursIdPourProcederPaiement: -1,
    coursDejaAchete: false,
    eleve: '',
    rafraichissementDonneesNecessaire: false,
  }),
  getters: {
  },
  actions: {
    async definirEleveEcoleGuid(eleveId) {
      try {
        this.chargement = true;
        this.eleveEcoleGuid = await PaiementAjax.definirEleveEcoleGuid(eleveId);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async eleveDefinirCours(eleveId) {
      try {
        this.chargement = true;
        this.coursPageConfirmation = await PaiementAjax.eleveDefinirCours(eleveId);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async eleveDefinirCoursEleve(eleveId) {
      try {
        this.chargement = true;
        this.coursElevePageConfirmation = await PaiementAjax.eleveDefinirCoursEleve(eleveId);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async effectuerRemboursementPartiel(remboursement) {
      try {
        this.chargement = true;
        await PaiementAjax.effectuerRemboursementPartiel(remboursement.coursEleveId, remboursement.montantRemboursementPartiel, remboursement.provenanceEleve);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.rafraichissementDonneesNecessaire = true;
        this.chargement = false;
      }
    },
    async definirIdEleveSelonGuid(guid) {
      try {
        this.chargement = true;
        this.idEleve = await PaiementAjax.definirIdEleveSelonGuid(guid);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async retirerEtatListeAttente(factureId) {
      try {
        this.chargement = true;
        this.coursModifies = await PaiementAjax.retirerEtatListeAttente(factureId);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirBlocsSelonId(blocsId) {
      try {
        this.chargement = true;
        this.blocs = await PaiementAjax.obtenirBlocsSelonId(JSON.stringify(blocsId));
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirTransactionsSelonId(listeCoursEleveId) {
      try {
        this.chargement = true;
        this.transactions = await PaiementAjax.ObtenirTransactionsSelonCoursEleveId(listeCoursEleveId);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirPlaceDansListeAttenteSelonCoursCourant(definirPlaces) {
      try {
        this.chargement = true;
        this.coursEleveNoPlaceListeAttente = await PaiementAjax.definirPlaceDansListeAttenteSelonCoursCourant(definirPlaces.listeCoursEleve, definirPlaces.anneeScolaire);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async verifierSiPeutPayer(coursEleveId) {
      try {
        this.chargement = true;
        this.peutPayer = await PaiementAjax.verifierSiPeutPayer(coursEleveId);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirCoursIdSelonCoursEleveId(coursEleveId) {
      try {
        this.chargement = true;
        this.coursIdPourProcederPaiement = await PaiementAjax.definirCoursIdSelonCoursEleveId(coursEleveId);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async verifierCoursEstDejaAchete(coursEleveId) {
      try {
        this.chargement = true;
        this.coursDejaAchete = await PaiementAjax.verifierCoursEstDejaAchete(coursEleveId);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async obtenirEleve(idEleve) {
      try {
        this.chargement = true;
        this.eleve = await PaiementAjax.obtenirEleve(idEleve);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
  },
});
